export default {
  docs: [],
  totalDocs: 0,
  search: "",
  serviceType: "all",
  status: "all",
  visitType: "all",
  loading: false,
  page: 1,
  totalPages: 0,
  sort: "-visitedAt"
};
